import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  FaChalkboardTeacher,
  FaGraduationCap,
  FaAward,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import DrNarendraOjhaImage from "../../assets/images/teachers/dr-narendra-ojha.png";
import RameshUpadhyayImage from "../../assets/images/teachers/ramesh-upadhyay.png";
import RashmiSatyarthiImage from "../../assets/images/teachers/rashmi-satyarthi.png";
import ManojKumarImage from "../../assets/images/teachers/mr-manoj-kumar.png";

const TeachersSection = () => {
  const teachers = [
    {
      id: 4,
      name: "Mr Manoj Kumar",
      image: ManojKumarImage,
      role: "Founder, Chairman & Director",
      department: "Management",
      qualification: "M.Sc (Chemistry)",
      color: "from-purple-100 to-pink-100",
    },
    {
      id: 1,
      name: "Rashmi Satyarthi",
      image: RashmiSatyarthiImage,
      role: "Co-Ordinator",
      department: "Management",
      qualification: "B.Sc, B.Ed",
      color: "from-purple-100 to-pink-100",
    },
    {
      id: 2,
      name: "Dr. Narendra Ojha",
      image: DrNarendraOjhaImage,
      role: "Principle",
      department: "Management",
      experience: "32+ Years",
      qualification: "PhD. (Malaysia)",
      color: "from-blue-100 to-cyan-100",
    },
    {
      id: 3,
      name: "Ramesh Upadhyay",
      image: RameshUpadhyayImage,
      role: "Vice-Principle",
      department: "IT",
      experience: "15+ Years",
      qualification: "M.Sc (English honours)",
      color: "from-green-100 to-emerald-100",
    },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1280 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1280, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  const CustomLeftArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-0 z-10 flex items-center justify-center w-10 h-10 text-gray-600 transition-all duration-300 transform -translate-y-1/2 bg-white border border-gray-300 rounded-full shadow-lg top-1/2 hover:bg-gray-50 hover:border-gray-400"
    >
      <FaChevronLeft className="w-4 h-4" />
    </button>
  );

  const CustomRightArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-0 z-10 flex items-center justify-center w-10 h-10 text-gray-600 transition-all duration-300 transform -translate-y-1/2 bg-white border border-gray-300 rounded-full shadow-lg top-1/2 hover:bg-gray-50 hover:border-gray-400"
    >
      <FaChevronRight className="w-4 h-4" />
    </button>
  );

  const getDeptColor = (dept) => {
    switch (dept.toLowerCase()) {
      case "management":
        return "bg-purple-100 text-purple-700";
      case "it":
        return "bg-indigo-100 text-indigo-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <section className="">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto mb-8 text-center">
          <div className="inline-flex items-center px-3 py-1 mb-3 text-xs font-medium text-purple-600 rounded-full bg-purple-50">
            <FaChalkboardTeacher className="w-3 h-3 mr-1.5" />
            Our Faculty
          </div>
          <h2 className="mb-3 text-2xl font-bold text-gray-900">
            Meet Our Expert Faculty
          </h2>
          <p className="text-sm text-gray-600">
            Dedicated educators shaping young minds with passion and expertise
          </p>
        </div>

        <div className="relative px-8 mb-8">
          <Carousel
            responsive={responsive}
            arrows
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            showDots={false}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={4000}
            keyBoardControl={true}
            containerClass="carousel-container"
            itemClass="px-2"
            className="pb-4"
          >
            {teachers.map((teacher) => (
              <div key={teacher.id} className="p-2">
                <div className="relative overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-md group rounded-xl">
                  {/* Teacher Image */}
                  <div className="relative overflow-hidden h-52">
                    <img
                      src={`${teacher.image}`}
                      alt={teacher.name}
                      className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                    />
                    {/* Experience Badge */}
                    {teacher.experience && (
                      <div className="absolute top-3 right-3">
                        <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-white/90 backdrop-blur-sm">
                          <FaAward className="w-3 h-3 text-amber-500" />
                          <span className="text-xs font-medium text-gray-700">
                            {teacher.experience}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="p-5">
                    {/* Department Badge */}
                    <div className="mb-3">
                      <span
                        className={`inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-[10px] ${getDeptColor(
                          teacher.department
                        )}`}
                      >
                        {teacher.department}
                      </span>
                    </div>

                    {/* Name and Role */}
                    <h3 className="mb-1 text-lg font-bold text-gray-900">
                      {teacher.name}
                    </h3>
                    <div className="mb-3 text-sm text-gray-600">
                      {teacher.role}
                    </div>

                    {/* Qualification */}
                    <div className="flex items-start gap-2">
                      <FaGraduationCap className="w-4 h-4 mt-0.5 text-gray-400 flex-shrink-0" />
                      <span className="text-xs text-gray-700">
                        {teacher.qualification}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default TeachersSection;
